module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAAAaCAYAAADR2YAqAAABHElEQVRoQ+3XMQrCQBAF0J0VtbSyEvECNlYewROIIZJgGllPoVcQBEkaTZH0NhYK4rlEspLCQtloJCbT/LSZmQ9vhkDIcudLIloJPJUKaK1XVGkiwl4EgM94EMAHPqMAYzQuH/iMAozRuHzgMwowRuPygc8owBiNywc+owBjNC6/RHzLmQ9rUrSiMDiZYoBfIv7EUX0p9ZmkUPHOP7xHAb9E/HS05aoBkT6aFgD8kvE/LQD4FeBnLQD4FeGbFgD8H/Cns4Wd6CT6oSWr9CbvjTbw/yCZd4TleV2ZNC+C9Cbe+2vg55UrWPcOn44DfkHUPO0meODnkStYkwUP/IKw39rHrurUSVyf33j84X4T++N721MjkVAvDreBaewDneRV5yj+HUAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/news/news-arrow.png
// module id = VKWq
// module chunks = 1